import { Modal, Form, Input, Checkbox } from "antd";
import React from "react";
import { IOrganisation } from "../../../organisations/model/Organisation";

export interface Props {
  modalVisible: boolean;
  loading: boolean;
  title: string;
  okText: string;
  cancelText: string;
  onCancel: () => any;
  onOK: (isHarmonized: boolean, harmonizationLabel: string) => any;
  organisations?: IOrganisation[];
  selectedOrganisationIds?: number[];
  onTextValueChange: (orgId: number, text: string) => any;
  prefix: string;
}
export default function BulkEditorFormModal({
  cancelText,
  modalVisible,
  okText,
  onCancel,
  onTextValueChange,
  onOK,
  organisations,
  selectedOrganisationIds,
  title,
  prefix,
  loading
}: Props) {
  const [form] = Form.useForm();
  const isHarmonized = Form.useWatch("isHarmonized", form);
  const harmonizationLabel = Form.useWatch("harmonizationLabel", form);

  const onSave = () => {
    form
      .validateFields()
      .then((result) => {
        onOK(isHarmonized, harmonizationLabel);
      })
      .catch(console.error);
  };
  return (
    <Modal
      okButtonProps={{
        loading: loading
      }}
      open={modalVisible}
      title={title}
      okText={okText}
      cancelText={cancelText}
      onCancel={onCancel}
      onOk={onSave}
    >
      <Form layout="vertical" form={form}>
        {selectedOrganisationIds?.map((org) => {
          let organisation = organisations?.find((o) => o.id === org);
          return (
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vrijednost je obavezna"
                }
              ]}
              name={org}
              key={`form-${prefix}-org-${org}`}
              label={organisation?.name}
            >
              <Input onChange={(e) => onTextValueChange(org, e.target.value)} />
            </Form.Item>
          );
        })}
        <Form.Item
          name={"isHarmonized"}
          initialValue={true}
          valuePropName="checked"
        >
          <Checkbox>Harmoniziraj podatke</Checkbox>
        </Form.Item>
        <Form.Item
          name={"harmonizationLabel"}
          label={"Usaglašeni naziv"}
          hidden={!isHarmonized}
          rules={[
            {
              required: isHarmonized,
              message: "Vrijednost je obavezna"
            }
          ]}
        >
          <Input disabled={!isHarmonized} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
